export default __webpack_public_path__ + "static/media/ThaiSansNeue-ExtraBold.2fece458.otf";